import { EXCLUDED_DROPOFF_LOCATIONS } from 'src/utils/Constants';

export const DELIVERED_LOCATION_LABEL_KEY = 'swiship_dropoff_location_label';

// STS `DeliveryLocationCodeToTranslatorKey` config map:
// https://code.amazon.com/packages/ShipmentTrackingService/blobs/mainline/--/configuration/brazil-config/app/ShipmentTrackingService.cfg#L21241
// Every translator key STS can emit, EXCEPT the mc_* individual-descriptor keys, which are
// intentionally omitted for privacy (mc_boy/mc_girl/mc_man/mc_woman). 
export const SUPPORTED_DELIVERED_LOCATION_KEYS: string[] = [
  // doors & porches
  'shiptrack_loc_front_door_27941',
  'shiptrack_loc_front_door_or_porch',
  'shiptrack_loc_front_porch',
  'shiptrack_loc_porch_27945',
  'shiptrack_loc_back_porch',
  'shiptrack_loc_back_door_or_porch',
  'shiptrack_loc_side_door_27943',
  'shiptrack_loc_side_door_or_porch',
  'shiptrack_loc_rear_door_27942',
  // structures & grounds
  'shiptrack_loc_garage_27944',
  'shiptrack_loc_carport_27948',
  'shiptrack_loc_patio_27947',
  'shiptrack_loc_deck_27946',
  'shiptrack_loc_shipping_dock_33001',
  'shiptrack_loc_garden',
  'shiptrack_loc_greenhouse',
  'shiptrack_loc_shed',
  'shiptrack_loc_outbuilding_35629',
  'shiptrack_loc_conservatory',
  'shiptrack_loc_behind_wheelie_bin',
  // mail & post
  'shiptrack_loc_mailbox_27949',
  'shiptrack_loc_mail_slot_29417',
  'shiptrack_loc_mail_room_32996',
  'shiptrack_loc_po_box',
  'shiptrack_loc_british_force_po',
  'shiptrack_loc_armed_forces_po',
  // lockers, pickup & stores
  'shiptrack_loc_parcel_locker',
  'shiptrack_loc_smart_parcel_locker',
  'shiptrack_loc_partner_parcel_locker',
  'shiptrack_loc_locker',
  'shiptrack-loc-convenience-store_57092',
  'shiptrack-loc-carrier-facility_57093',
  'shiptrack_loc_nearby_store',
  // offices & reception
  'shiptrack_loc_front_desk_33674',
  'shiptrack_loc_office_33675',
  'shiptrack_loc_property_office',
  'shiptrack-loc-leasing-office',
  // other
  'shiptrack_loc_secure_location_35631',
  'shiptrack_loc_as_instructed_35630',
  'shiptrack_loc_frieght_forwarder',
  // received by (role)
  'shiptrack_loc_resident_33676',
  'shiptrack_loc_receptionist_32998',
  'shiptrack_loc_security_guard',
  'shiptrack_loc_colleague',
  'shiptrack_loc_customer',
  'shiptrack-act-left-with-neighbor_995',
];

// Show the "Delivered location" row only when DELIVERED, the key is allowlisted, and there is no
// displayable AMZL drop-off (the two are mutually exclusive; drop-off wins). 
export const shouldShowDeliveredLocation = (
  transitState?: string,
  additionalLocationTranslatorKey?: string,
  packageDropOffLocation?: string
): boolean => {
  const hasDisplayableDropOff =
    !!packageDropOffLocation && !EXCLUDED_DROPOFF_LOCATIONS.includes(packageDropOffLocation);
  return (
    transitState === 'DELIVERED' &&
    !hasDisplayableDropOff &&
    !!additionalLocationTranslatorKey &&
    SUPPORTED_DELIVERED_LOCATION_KEYS.includes(additionalLocationTranslatorKey)
  );
};
